
import React, {Component, Fragment} from 'react'
import { connect } from 'react-redux'
import DispatchTimeDialogue from '../../misc/DispatchTimeDialogue'

var saleCommonUtility = require('../../../../../utils/domain/sales/saleCommonUtility');
var saleContextUtil = require('../../../utils/saleContextUtil.js');
var constants = require('../../../../../utils/domain/constants');

class DispatchTimeToolbarButton extends Component 
{
    constructor(props)
    {
        super(props);

        this.renderDispatchTimeDialogue = this.renderDispatchTimeDialogue.bind(this);

        this.state = {};
        this.state.showDispatchTimeDialogue = false;
    }

    render()
    {
        let sale = this.props.saleContext.sale;
        
        let canAddTimes = saleCommonUtility.canAddTimes(sale);      
        return (<Fragment>
                    <div style={{textAlign:'center', opacity:canAddTimes ? 1 : 0.5, color: "#787878"}}
                             onClick={(event)=>
                             {
                                event.stopPropagation();

                                if (!canAddTimes)
                                    return; 

                                this.state.showDispatchTimeDialogue = true;
                                this.setState({});
                             }}>
                            <ClockIcon size="2.2vw"/>
                        </div>
                    {this.renderDispatchTimeDialogue()}
                </Fragment>)
    }

    renderDispatchTimeDialogue()
    {
        if (!this.state.showDispatchTimeDialogue)
            return null;

        return <DispatchTimeDialogue    sale={this.props.saleContext.sale} saleContext={this.props.saleContext}
                                        onClose={(timeModified)=>
                                            {
                                                this.state.showDispatchTimeDialogue = false;
                                                this.setState({});

                                                if (timeModified)
                                                    saleContextUtil.raiseSaleContextSaleChangeEvent(false);
                                            }}/>
    }
}

const mapStateToProps = state => 
{
    return { 
                saleContext: state.saleContext,
                saleChangedDateTime: state.saleContext.saleChangedDateTime
           }
}

export default connect(mapStateToProps)(DispatchTimeToolbarButton)

const ClockIcon = ({size})=>{
    return(
        <svg width={size} height={size} xmlns="http://www.w3.org/2000/svg" fill='none' viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"></path>
</svg>
    )
}